import {createAction} from 'redux-actions';
import {curry} from 'ramda';
import tryToCatch from 'try-to-catch';
import {updateQcJobReportStatus} from '@pluto/rest';
import {
    DispatchAny,
    UpdateQcJobStatusParams,
} from '@pluto/@types';
import {setNotificationAction} from '@pluto/notification';
import {QC_JOB_STATE_SET} from '../../../QCTools/Redux/QCToolsActions';

export const updateQcJobReportStatusAction = curry(async (qcJobId: string, params: UpdateQcJobStatusParams, dispatch: DispatchAny) => {
    const [error, success] = await tryToCatch(updateQcJobReportStatus, qcJobId, params);
    
    if (!error) {
        const {data} = success;
        
        return dispatch(getQcJobStatusesAction(data));
    }
    
    return dispatch(setNotificationAction({
        type: 'error',
        text: 'QC Job can not be failed without at least one failure reason(Note).',
    }));
});

export const getQcJobStatusesAction = createAction(QC_JOB_STATE_SET);
